import { useMemo, useState } from 'react';
import { money } from '../lib/format';
import { useLookups } from '../lib/lookups';

export default function Catalog() {
  const { decorations, vendors, loaded } = useLookups();
  const [tab, setTab] = useState<'decorations' | 'vendors'>('decorations');
  const [q, setQ] = useState('');
  const [vendor, setVendor] = useState('');

  const deco = useMemo(() => decorations.filter((d) =>
    (!vendor || d.vendor_id === vendor) &&
    (!q || `${d.name} ${d.category ?? ''} ${d.vendors?.name ?? ''}`.toLowerCase().includes(q.toLowerCase()))), [decorations, q, vendor]);

  return (
    <div className="page">
      <div className="page-head">
        <h1>Catalog</h1>
        <input className="search" placeholder="Search" value={q} onChange={(e) => setQ(e.target.value)} />
        {tab === 'decorations' && (
          <select value={vendor} onChange={(e) => setVendor(e.target.value)} style={{ width: 220 }}>
            <option value="">All vendors</option>
            {vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
          </select>
        )}
      </div>
      <div className="tabs">
        <button className={tab === 'decorations' ? 'on' : ''} onClick={() => setTab('decorations')}>Decorations <span className="count">{decorations.length}</span></button>
        <button className={tab === 'vendors' ? 'on' : ''} onClick={() => setTab('vendors')}>Vendors <span className="count">{vendors.length}</span></button>
      </div>
      <div className="card">
        {tab === 'decorations' ? (
          <table className="grid">
            <thead><tr><th>Name</th><th>Category</th><th>Vendor</th><th className="num">Setup</th></tr></thead>
            <tbody>
              {deco.map((d) => (
                <tr key={d.id}><td>{d.name}</td><td>{d.category}</td><td>{d.vendors?.name}</td><td className="num">{money(d.setup_price)}</td></tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="grid">
            <thead><tr><th>Name</th><th>Email</th><th>Local</th></tr></thead>
            <tbody>
              {vendors.filter((v) => !q || v.name.toLowerCase().includes(q.toLowerCase())).map((v) => (
                <tr key={v.id}><td>{v.name}</td><td>{v.email && <a href={`mailto:${v.email}`}>{v.email}</a>}</td><td>{v.is_local ? 'Yes' : 'Offshore'}</td></tr>
              ))}
            </tbody>
          </table>
        )}
        {!loaded && <div className="empty">Loading…</div>}
      </div>
      <p className="muted small">Products aren’t in the catalogue yet — type them into the item builder as you quote.</p>
    </div>
  );
}
